<template>
    <div class="get-today-detail">
        <p class="get-today-detail__text">
            <span>
                {{ messages.reserveDetails }}
            </span>
        </p>
        <div v-if="reserveShop" class="get-today-shop">
            <h6 class="get-today-title">
                {{ messages.shop }}
            </h6>
            <p  class="get-today-shop__address">
                {{ reserveShop.address }}
            </p>
            <p class="get-today-shop__phone">
                {{ reserveShop.phone }}
            </p>
            <p class="get-today-shop__time">
                {{ reserveShop.schedule }}
            </p>
        </div>
        <h6 class="get-today-title">
            <span>
                {{ messages.jewelry }}
            </span>
        </h6>
        <ProductModal
            :result="result"
            :messages="messages"
        />
        <h6 class="get-today-title">
             <span>
                {{ messages.fillOutForm }}
            </span>
        </h6>
        <form @submit.prevent="handlerSubmit" class="get-today-form">
            <input type="hidden" name="deliveryId" value="2">
            <input type="hidden" name="saveBasket" value="Y">
            <input type="hidden" name="orderType" value="Резерв">
            <input type="hidden" name="productId" :value="id">
            <input type="hidden" name="storeId" :value="reserveShop.id">
            <DefInput
                name="surname"
                :placeholder="messages.surname"
                :value="authInfo.surname"
                :required="true"
            />
            <DefInput
                name="name"
                :placeholder="messages.name"
                :value="authInfo.user_name"
                :required="true"
            />
            <DefPhone
                name="phone"
                :label="messages.phone"
                :value="authInfo.user_phone_number"
                :required="true"
            />
            <DefButtonPrimary type="submit">
                <span>
                    {{ messages.submitAnOrder }}
                </span>
            </DefButtonPrimary>
        </form>
    </div>
</template>

<script setup>
import { defineProps, computed, getCurrentInstance, defineEmits } from 'vue';
import { useStore } from 'vuex';

import DefInput from "../../def/DefInput/DefInput";
import DefPhone from "../../def/DefPhone/DefPhone";
import DefButtonPrimary from "../../def/DefButtonPrimary/DefButtonPrimary";

const {
    result,
    messages,
    reserveShop,
} = defineProps(['result', 'messages', 'reserveShop']);

const emit = defineEmits(['close'])

const {
    state: {
        personal: {
            data: {
                authInfo,
            }
        }
    },
    dispatch,
} = useStore();

const  {
    appContext : {
        config: {
            globalProperties : { $DefModal }
        }
    }
} = getCurrentInstance();

const id = computed(() => {
    return result?.offer?.id ?? result?.id;
})

const handlerSubmit = async ({ target }) => {
    const formData = new FormData(target);
    const requestData = {};

    for (const pair of formData.entries()) {
        requestData[pair[0]] = pair[1];
    }

    const responseData = await dispatch('basket/createOrderByOneClick', requestData);
    emit('close');
    $DefModal.show({
        name: 'DefBuyOneClickThanks',
        width: '340px',
        props: {
            result: responseData,
        },
    });
}

</script>

<script>
export default {
    name: 'GetTodayDetail',
}
</script>

<style lang="scss" scoped>
.get-today-detail{
    &__text{
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        color: var(--color-dark-grey);
        margin-bottom: 32px;
    }
    :deep(.product-modal){
        margin-bottom: 32px;
        @include point-md{
            margin-bottom: 40px;
        }
    }
}
.get-today-shop{
    margin-bottom: 32px;
    @include point-md{
        margin-bottom: 40px;
    }
    &__address{
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        margin-bottom: 8px;
    }
    &__phone,
    &__time {
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        color: var(--color-dark-grey);
    }
}
.get-today-title{
    font-weight: 500;
    font-size: rem(14);
    line-height: 130%;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin-bottom: 16px;
    @include point-md{
        font-size: rem(16);
        margin-bottom: 24px;
    }
}
.get-today-form{
    display: grid;
    grid-row-gap: 8px;
    max-width: 480px;
    :deep(.def-button-primary){
        margin-top: 8px;
        @include point-md{
            margin-top: 16px;
            max-width: 280px;
        }
    }
}
</style>